module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - bookchukil.802f00a3.pdf";